import { GET_COMMENTS_SUCCESS, GET_MENTION_STAFF, GET_MENTION_STAFF_SUCCESS } from './comment.type';

const initialState = {
    /** { [`${onModel}:${resourceId}`]: { data: CommentResponseDTO[], count: number } } */
    threads: {},
    /** staff candidates for the @mention autocomplete: [{ id, firstName, lastName }] */
    mentionStaff: [],
    /** 1-based page of the currently loaded @mention staff list */
    mentionPage: 1,
    /** whether another page of @mention staff is available to load on scroll */
    mentionHasMore: true,
    /** in-flight flag for the @mention staff fetch (guards duplicate scroll requests) */
    mentionLoading: false,
};

export const commentReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COMMENTS_SUCCESS:
            return {
                ...state,
                threads: {
                    ...state.threads,
                    [action.payload.key]: {
                        data: action.payload.data,
                        count: action.payload.count,
                    },
                },
            };
        case GET_MENTION_STAFF:
            return { ...state, mentionLoading: true };
        case GET_MENTION_STAFF_SUCCESS: {
            const { staff = [], page = 1, hasMore = false } = action.payload || {};
            // Page 1 replaces (fresh open / new search); later pages append, de-duped by id.
            const merged =
                page > 1
                    ? [...state.mentionStaff, ...staff.filter((s) => !state.mentionStaff.some((e) => e.id === s.id))]
                    : staff;
            return {
                ...state,
                mentionStaff: merged,
                mentionPage: page,
                mentionHasMore: hasMore,
                mentionLoading: false,
            };
        }
        default:
            return state;
    }
};
